export const useClickOutside = (
	refs: Array<{ current: Element | null | undefined }>,
	onClickOutside: () => void
): (() => void) => {
	const handler = (e: Event) => {
		const path = (e as Event & { path?: EventTarget[] }).path || e.composedPath();
		if (!refs.some((ref) => ref.current && path.includes(ref.current))) {
			onClickOutside();
		}
	};
	document.addEventListener("click", handler);
	return () => document.removeEventListener("click", handler);
};
